import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap-5';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { profilePremiumSignupUrl } from 'bundles/connect/helpers/prospect_api';
import { faLock } from '@fortawesome/pro-regular-svg-icons';

type ToggleProps = {
  bordered?: boolean;
  checked: boolean;
  disabled?: boolean;
  label: React.ReactNode;
  onClick: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export default function Toggle({
  bordered = false,
  checked,
  disabled = false,
  label,
  onClick
}: ToggleProps) {
  const id = useMemo(() => uuid(), []);

  const labelContent = disabled ? (
    <a
      className="fw-bolder text-dark"
      href={profilePremiumSignupUrl}
      rel="noopener noreferrer"
      target="_blank"
    >
      <FontAwesomeIcon className="text-primary me-2 ms-1" icon={faLock} />
      {label}
    </a>
  ) : (
    label
  );

  return (
    <div
      className={
        classNames(
          {
            'active': checked,
            'flex-row-reverse form-control as-button bg-white': bordered,
          }
        )
      }
      style={{ width: '100%' }}
    >
      <Form.Check
        checked={checked}
        className={classNames('m-0 p-0 d-flex align-items-center gap-2', { 'fw-bolder': !bordered })}
        disabled={disabled}
        id={`toggle-${id}`}
        label={labelContent}
        type="switch"
        onChange={onClick}
      />
    </div>
  );
}
